module.exports = __webpack_public_path__ + "img/dianjiyun6.90396d5f.png";